import { ImportSessionFileData, ImportSessionResource } from '../@types';
import { ImportStatusCode } from '../configs/enums';
import { IMPORT_SESSION_FILE_DATA } from '../configs/envs';

export const setImportSessionData = (resourceType: string, importFileData: ImportSessionFileData) => {
  importFileData && sessionStorage.setItem(`${IMPORT_SESSION_FILE_DATA} - ${resourceType}`, JSON.stringify(importFileData));
};

export const getImportSessionData = (resourceType: string) => {
  const importDataJson = sessionStorage.getItem(`${IMPORT_SESSION_FILE_DATA} - ${resourceType}`);
  if (importDataJson) {
    try {
      return JSON.parse(importDataJson);
    } catch {
      return undefined;
    }
  }
};

export const clearImportSessionData = (resourceType: string) => {
  sessionStorage.removeItem(`${IMPORT_SESSION_FILE_DATA} - ${resourceType}`);
};

export const getImportedRecordsCount = (data: ImportSessionResource[], importStatus: string) => {
  return data?.filter((record) => record.statusCode === importStatus).length;
};

export const getImportedRecordsStatusCount = (data: any, importStatus: string) => {
  const statusData = data?.find((record: any) => record.statusCode === importStatus);
  const count = statusData ? statusData.count : 0;
  return count;
};

export const getImportFailedRecords = (data: any) => {
  return data?.find((record: any) => record.statusCode === ImportStatusCode.ProcessingFailed)?.fileLines;
};